import { createContext } from 'react';
import { GeolocationManager } from 'record-it-utils/location/GeolocationManager/GeolocationManager';

export const GeolocationManagerContext =
  createContext<GeolocationManagerContextValue>({
    get manager(): never {
      throw new Error(
        'GeolocationManagerContext not initialized, make sure you are inside the GeolocationManagerContext'
      );
    }
  });

export type GeolocationManagerContextValue = {
  manager: GeolocationManager;
};
